/** Formatting helpers shared by the mail list/reader. Pure + locale-tolerant. */

/** Compact date for message rows: time today, weekday this week, else date. */
export function formatMailDate(iso: string | null | undefined, locale: string): string {
  if (!iso) {
    return "";
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const now = new Date();
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  if (sameDay) {
    return date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  }
  const sameYear = date.getFullYear() === now.getFullYear();
  return date.toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: sameYear ? undefined : "numeric",
  });
}

/** Parses a `Display Name <addr@host>` header into a friendly label. */
export function displayFromAddress(raw: string): string {
  const match = /^\s*"?([^"<]*?)"?\s*<[^>]+>\s*$/.exec(raw);
  const name = match?.[1]?.trim();
  if (name) {
    return name;
  }
  return raw.trim();
}

/** Extracts the bare `addr@host` from a full address header. */
export function bareAddress(raw: string): string {
  const match = /<([^>]+)>/.exec(raw);
  return (match?.[1] ?? raw).trim();
}

/** Human-readable byte size for attachments. */
export function formatSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
